import React from "react";

export default function ReserveButton({ children = "Reserve your spot now" }) {
  return (
    <button
      type="button"
      onClick={() => {
        const registerSection = document.getElementById("register-stepper");
        if (registerSection) {
          registerSection.scrollIntoView({ behavior: "smooth" });
        } else {
          console.error("Register section not found");
        }
      }}
      className="
        bg-gradient-to-r from-pink-500 to-pink-400
        hover:from-pink-600 hover:to-pink-500
        text-white font-semibold
        py-2 px-6
        rounded-full
        shadow-lg
        transition-colors duration-300
      "
    >
      {children}
    </button>
  );
}
